import { Input, Col, Row, Space, DatePicker } from "antd";
import { useState, useCallback, useMemo, useRef, useEffect } from "react";
import { debounce } from "lodash";

interface OrderControlProps {
  onApply: (
    client: string,
    orderNumber: string,
    startDate: string,
    endDate: string,
  ) => void;
}

const { RangePicker } = DatePicker;

const OrderControl = (props: OrderControlProps) => {
  const [filters, setFilters] = useState({
    client: "",
    orderNumber: "",
    startDate: "",
    endDate: "",
  });

  const filtersRef = useRef(filters);

  useEffect(() => {
    filtersRef.current = filters;
  }, [filters]);

  const debouncedApply = useMemo(
    () =>
      debounce(() => {
        const { client, orderNumber, startDate, endDate } = filtersRef.current;
        props.onApply(client, orderNumber, startDate, endDate);
      }, 1500),
    [props],
  );

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string,
  ) => {
    const newFilters = { ...filters, [key]: e.target.value };
    setFilters(newFilters);
    debouncedApply();
  };

  const onApply = useCallback(() => {
    const { client, orderNumber, startDate, endDate } = filters;
    props.onApply(client, orderNumber, startDate, endDate);
  }, [filters, props]);

  return (
    <Row gutter={[10, 10]} align="middle">
      <Col xs={24} sm={12} md={8} lg={4}>
        <Space direction="vertical" style={{ width: "100%" }}>
          Cliente
          <Input
            allowClear
            placeholder="cliente"
            value={filters.client}
            onChange={(e) => handleInputChange(e, "client")}
            onPressEnter={onApply}
          />
        </Space>
      </Col>
      <Col xs={24} sm={12} md={8} lg={4}>
        <Space direction="vertical" style={{ width: "100%" }}>
          Nro. Pedido
          <Input
            allowClear
            placeholder="nro. pedido"
            value={filters.orderNumber}
            onChange={(e) => handleInputChange(e, "orderNumber")}
            onPressEnter={onApply}
          />
        </Space>
      </Col>
      <Col xs={24} sm={12} md={8} lg={6}>
        <Space direction="vertical" style={{ width: "100%" }}>
          Fecha
          <RangePicker
            style={{ width: "100%" }}
            onChange={(_dates, dateStrings) => {
              const newFilters = {
                ...filters,
                startDate: dateStrings[0] || "",
                endDate: dateStrings[1] || "",
              };
              setFilters(newFilters);
              debouncedApply();
            }}
          />
        </Space>
      </Col>
    </Row>
  );
};

export default OrderControl;
